module.exports = __webpack_public_path__ + "img/photo_books_4.685634de.png";